module.exports = __webpack_public_path__ + "static/media/vtm-10000-1957-1971.b1915211.png";